import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M19.87 7l1.22 2 .58 1H28v15H4V10h6.33l.58-1 1.22-2h7.74m0-2h-7.74a2 2 0 00-1.71 1L9.2 8H7a1 1 0 00-2 0H4a2 2 0 00-2 2v15a2 2 0 002 2h24a2 2 0 002-2V10a2 2 0 00-2-2h-5.2l-1.22-2a2 2 0 00-1.71-1z"/><path d="M26 11a1 1 0 101 1 1 1 0 00-1-1zM16 12a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7 7 7 0 00-7-7z"/>';
export var CameraOutlineSVG = function CameraOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CameraOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CameraOutlineSVG);